<template>
  <v-container fluid>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Listado de Mis Ordenes
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="getOrdenes">
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                  v-model="fechaInicio"
                  label="Fecha Inicio"
                  type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                  v-model="fechaFin"
                  label="Fecha Fin"
                  type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                  v-model="search"
                  label="Buscar codigo encargado"
                  single-line
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" class="text-center">
              <v-btn color="accent"  medium title="Buscar" type="submit" prepend-icon="mdi-history" class=" mt-5" :loading="loading">
                Listar
              </v-btn>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <v-btn color="primary"  medium title="Buscar" type="submit" prepend-icon="mdi-plus-circle-outline" class="mt-5" @click="$router.push('/orden/create')" :loading="loading">
                Nuevo
              </v-btn>
            </v-col>
          </v-row>
          </v-form>
        </v-card-text>
        <v-simple-table density="compact" theme="grey" class="elevation-1">
          <thead>
          <tr>
            <th>Nro.</th>
            <th class="text-left">Código</th>
            <th class="text-left">Fecha Recibido</th>
            <th class="text-left">Solicitante</th>
            <th class="text-left">Encargado</th>
            <th class="text-left">Detalle</th>
            <th class="text-left">Estado</th>
            <th class="text-left">Fecha Atendido</th>
            <th class="text-left">Fecha Finalizado</th>
            <th class="text-left">Total</th>
            <th class="text-left">Observación</th>
            <th class="text-left">Acciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(orden, index) in misOrdenes" :key="orden.id">
            <td width="3%">{{ index+1 }}</td>
            <td width="5%">{{ orden.codigo }}</td>
            <td width="7%">{{ orden.fecha_recibido }}</td>
            <td width="10%">{{ orden.solicitante.funcionario.nombre_completo }}</td>
            <td width="10%">
              <div v-if="orden.encargado">
                {{ orden.encargado.funcionario.nombre_completo }}
              </div>
            </td>
            <td width="20%">{{ orden.detalle }}</td>
            <td width="7%">
              <v-chip variant="flat" :color="colorEstado(orden.estado)" dark>
                {{ orden.estado }}
              </v-chip>
            </td>
            <td width="7%">{{ orden.fecha_atendido }}</td>
            <td width="7%">{{ orden.fecha_finalizado }}</td>
            <td width="5%">{{ orden.total }}</td>
            <td width="10%">{{ orden.observacion }}</td>
            <td width="5%">
              <v-btn color="primary" variant="text" icon="mdi-eye" small class="text-none" title="Ver Detalle"
                    @click="$router.push('/orden/show/'+orden.id)">
                
              </v-btn>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import {http} from "@/config/HttpClient";
export default {
  name: "MisOrdenesIndex",
  data(){
    return{
      fechaInicio: moment().format('YYYY-MM-DD'),
      fechaFin: moment().format('YYYY-MM-DD'),
      search: '',
      misOrdenes: [],
      loading: false,
      estados: [
    {estado:'Iniciado', color: 'info'}, {estado:'Pendiente', color: 'orange'}, {estado:'Finalizado', color: 'success'}, {estado:'Anulado', color: 'red'}, {estado:'Todos', color: 'indigo'}]

    }
  },
  mounted() {
    // this.getOrdenes();
  },
  methods: {
    getOrdenes(){
      this.loading = true;
      // http.get('misOrdenes', {
      //   params: {
      //     fechaInicio: this.fechaInicio,
      //     fechaFin: this.fechaFin,
      //     search: this.search
      //   }
      // }).then(response => {
      //   this.misOrdenes = response.data;
      // }).catch(error => {
      //   console.log(error);
      // }).finally(() => {
      //   this.loading = false;
      // })
      http.get('misOrdenes').subscribe(response => {
        this.misOrdenes = response.data;
      }, error => {
        console.log(error);
      }).add(() => {
        this.loading = false;
      })
    },
    colorEstado(estado) {
    let color = 'grey'
    let esta = this.estados.find(el => el.estado == estado);
    if(esta) color = esta.color;
    return color;
  }
  }
}
</script>
<style scoped>
.fondo{
  z-index: 1 !important;
}
td, th {
    border: 1px solid #F0F0F0;
}
</style>
